import axiosApi from "../axiosInstance";
import { getStoredUser } from "../../helper/sessionHelper";
import { getReduxCompany } from "../../helper/sessionHelper";

export async function getUserDetailsByAccessToken(userData) {
    try {
        var request = {}
        const storedUser = getStoredUser();

        var response = (await axiosApi.post(
            `/UserLogin/getUserDetailsByAccessToken`,
            request,
            {
                headers: {
                    Authorization: `Bearer ${userData?.accessToken}`,
                }
            }));

        return response?.data;

    } catch (error) {
        console.log("Error getUserDetailsByAccessToken===>:", error);
        return response?.data;
    }
};


export async function getUserTypeList(request) {
    try {
        request = (request) ? request : {};
        request.userTypeId = request?.userTypeId ?? 0;
        request.userTypeName = request?.userTypeName ?? "";
        request.isActive = request?.isActive ?? null;

        const response = await axiosApi.post(`/UserType/GetUserTypes`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getUserTypeList===>:", error);
        return null;
    }
};


export async function getUserDropdown(request) {
    try {
        request = request || {};
        request.companyId = getReduxCompany()?.companyId || 1;
        const response = await axiosApi.post(`/User/GetUserDropdown`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getUserDropdown===>:", error);
        return null;
    }
};

export async function getUserByDepartmentId(departmentId) {
    try {
        const companyId = getReduxCompany()?.companyId || 1;
        const response = await axiosApi.get(`/User/GetUserDropdownByDepartmentId/` + departmentId + "/" + companyId);
        return response?.data;
    } catch (error) {
        console.log("Error getUserByDepartmentId===>:", error);
        return null;
    }
};

export async function getUserDropdownForIom(request) {
    try {
        const response = await axiosApi.post(`/User/GetUserDropdownForIom`, request);
        return response?.data;
    } catch (error) {
        console.log("Error getUserDropdownForIom===>:", error);
        return null;
    }
};

export async function getUsersByFilter(request) {
    try {
        const response = await axiosApi.post(`/User/GetUsersByFilter`, request);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getUsersByFilter===>:", error);
        return null;
    }
};

export async function UserLoginService(request) {
    try {
        const response = await axiosApi.post(`/UserLogin/UserLoginService`, request);
        return response?.data;
    } catch (error) {
        console.log("Error UserLoginService===>:", error);
        return null;
    }
};

export async function getUserDetailsByRefrestToken(request) {
    try {
        const response = await axiosApi.post(`/UserLogin/GetUserDetailsByRefrestToken`, request);
        return response?.data;
    } catch (error) {
        console.log("Error GetUserDetailsByRefrestToken===>:", error);
        return error?.response;
    }
};

export async function getIOMToUsersDropdown() {
    try {
        const response = await axiosApi.get(`/User/GetIomToUsersDropdown`);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getIOMToUsersDropdown===>:", error);
        return error?.response;
    }
};

export async function getUserByDesignationId(designationId) {
    try {
        const response = await axiosApi.get(`/User/GetUserByDesignationId/` + designationId);
        return response?.data?.data;
    } catch (error) {
        console.log("Error getUserByDesignationId===>:", error);
        return error?.response;
    }
};

export async function getApplicationModuleFeature(request) {
    try {
        var response = await axiosApi.post(`/UserFeature/GetApplicationModuleFeatureV3`, request);
        return response?.data;
    } catch (error) {
        console.log("Error getApplicationModuleFeatureV3===>:", error);
        return error?.response;
    }
};

export async function GetUserWiseFeatureMenu(request = {}) {
    try {
        request = request || {};
        //request.companyId = getReduxCompany()?.companyId || 1;
        var response = await axiosApi.post("/UserFeature/GetUserWiseFeatureMenu", request);
        return response?.data;
    } catch (error) {
        console.log("Error GetUserWiseFeatureMenu===>:", error);
        return error?.response;
    }
};

export async function GetUserFeaturePermission(request = {}) {
    try {
        request = request || {};
        request.companyId = request.companyId  || getReduxCompany()?.companyId || 1;
        var response = await axiosApi.post("/UserFeature/GetUserFeaturePermission", request || {});
        return response?.data;
    } catch (error) {
        console.log("Error GetUserFeaturePermission===>:", error);
        return error?.response;
    }
};

export async function UpdateIsApproved(userId, isApproved, modfiedBy) {
    try {
        var response = await axiosApi.get(`/User/UpdateIsApproved/${userId || 0}/${isApproved ?? true}/${modfiedBy || 0}`);
        return response?.data;
    } catch (error) {
        console.log("Error UpdateIsApproved===>:", error);
        return error?.response;
    }
};

